import React, { FC, useEffect, useState } from 'react'

type Item = {
  id: string
  buttonId: string
  text: string
}

type Props = {
  data: {
    items: Item[]
  }
}

const LeftNavWrap: FC<Props> = ({ data }) => {
  const { items } = data || { items: [] } // Ensure items is not null
  const [activeLink, setActiveLink] = useState<string | null>(null)

  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.scrollY
      let foundActiveLink = false

      items.forEach(item => {
        const targetElement = document.getElementById(item.buttonId)
        if (targetElement) {
          const targetPosition = targetElement.getBoundingClientRect().top + window.pageYOffset
          if (targetPosition <= scrollPosition) {
            setActiveLink(item.buttonId)
            foundActiveLink = true
          }
        }
      })

      if (!foundActiveLink) {
        setActiveLink(null)
      }
    }

    window.addEventListener('scroll', handleScroll)
    return () => {
      window.removeEventListener('scroll', handleScroll)
    }
  }, [items])

  const handleClick = (buttonId: string) => {
    setTimeout(() => {
      setActiveLink(buttonId) // Update active link state after a short delay
    }, 300) // Adjust the delay (in milliseconds) as needed
  }

  return (
    <div className="LeftNav">
      <ul>
        {items.map((item, index) => (
          <li
            key={index}
            className={item.buttonId === activeLink ? 'active' : ''}
            onClick={() => handleClick(item.buttonId)}>
            <a href={`#${item.buttonId}`}>{item.text}</a>
          </li>
        ))}
      </ul>
    </div>
  )
}

export default LeftNavWrap
